import classNames from "classnames";
import React from "react";

interface IPageItemProps {
  active: boolean;
  label: number;
  onChange: (value: any) => void;
}

export class PageItem extends React.PureComponent<IPageItemProps> {
  render() {
    const { active, label, onChange } = this.props;
    const baseClass = "el-pagination-list__item";
    const classes = classNames(baseClass, {
      [`${baseClass}--active`]: !!active,
    });

    return (
      <li className={classes}>
        <a href="#" onClick={onChange}>
          {" "}
          {label}{" "}
        </a>
      </li>
    );
  }
}
